import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  alpha,
  Box,
  Card,
  CardContent,
  Container,
  Grid2,
  Typography,
} from "@mui/material";
import theme, { responsiveFontSize } from "themes/Theme";
import { Link } from "react-router-dom";
import React from "react";
import AccordionUpIcon from "assets/svg/AccordionUpIcon";
import { FaqData } from "meta/faq";

const FaqSection = () => {
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel: any) => (_event: any, newExpanded: any) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <Box sx={styles.faqContainer}>
      <Container sx={{ py: 4 }}>
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Typography sx={styles.heading1}>
              Frequently asked<span>questions</span>
            </Typography>
            <Typography sx={styles.helpText}>
              Still need help?{" "}
              <Link to="/faq" style={styles.helpLink}>
                Get help Now
              </Link>
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Card sx={styles.cardContainer}>
              <CardContent>
                {FaqData.map((item, index) => (
                  <Accordion
                    expanded={expanded === `panel${index + 1}`}
                    onChange={handleChange(`panel${index + 1}`)}
                    disableGutters
                    key={index}
                    elevation={0}
                    sx={{
                      boxShadow: "none",
                      border: "none",
                      borderRadius: "8px",
                      overflow: "hidden",
                      backgroundColor:
                        expanded === `panel${index + 1}`
                          ? alpha(theme.palette.primary.light, 0.2)
                          : "transparent",
                    }}
                  >
                    <AccordionSummary
                      aria-controls="panel1d-content"
                      id="panel1d-header"
                      expandIcon={<AccordionUpIcon />}
                    >
                      <Typography sx={styles.accordionTitleText}>
                        {item.question}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography sx={styles.accordionDescriptionText}>
                        {item.answer}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </CardContent>
            </Card>
          </Grid2>
        </Grid2>
      </Container>
    </Box>
  );
};
export default FaqSection;
const styles = {
  faqContainer: {
    backgroundColor: theme.palette.secondary.main,
  },

  helpText: {
    fontSize: "clamp(0.7rem, 3.5vw,0.938rem)",
    fontWeight: 400,
    color: theme.palette.text.primary,
    marginTop: "2em",
  },
  heading3: {
    fontSize: "clamp(0.6rem, 3.4vw,0.75rem)",
    color: theme.palette.primary.main,
    fontWeight: 400,
  },
  heading1: {
    fontSize: responsiveFontSize(48),
    color: theme.palette.primary.main,
    fontWeight: 400,
    lineHeight: 1.2,
    marginTop: 2,
    "& span": {
      backgroundColor: alpha(theme.palette.primary.light, 0.2),
      color: theme.palette.custom?.black,
      borderRadius: "3em",
      px: 2,
    },
  },
  description: {
    color: theme.palette.text.secondary,
    fontSize: "clamp(1rem, 4vw,1rem)",
    fontWeight: 400,
    marginTop: 2,
  },
  flex1: {
    flex: 1,
  },
  cardContainer: {
    borderRadius: "2.5em",
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
    backgroundColor: "#FFFFFF",
  },
  helpLink: {
    color: theme.palette.primary.light,
    fontSize: "clamp(1rem, 4vw,1.125rem)",
  },
  accordionTitleText: {
    fontSize: responsiveFontSize(14),
    color: theme.palette.text.primary,
    fontWeight: 400,
  },
  accordionDescriptionText: {
    fontSize: responsiveFontSize(12),
    color: theme.palette.text.secondary,
    fontWeight: 400,
  },
};
